/**
 * MoreView — parent view for the sidebar `更多` tab. Renders a tab
 * strip and an inline child content area:
 *
 *   ┌─ view-title (更多) ───────────────────────────────────────┐
 *   ├─ moreSubsectionTabs (周报索引 / 更新日志) ────────────────┤
 *   ├─ child content (rendered in-place) ───────────────────────┤
 *
 * Subroute dispatch:
 *   `#/more`             → renderWeeksIndexView() body
 *   `#/more/changelog`   → renderChangelogView()   body
 *
 * This is the right-pane content; the sidebar's `更多` tab is the
 * outer container, owned by `sidebar.ts`. The route name is `more`
 * and `query.child` decides which child to mount.
 */

import { el } from "../dom";
import { renderWeeksIndexView } from "./weeks";
import { renderChangelogView } from "./changelog";
import { moreSubsectionTabs, type MoreChild } from "../components/moreSubsectionTabs";

export interface MoreViewOptions {
  child: MoreChild;
}

export function renderMoreView({ child }: MoreViewOptions): HTMLElement {
  const title = el("div", { class: "view-title" }, [
    el("h1", null, "更多"),
    el("p", { class: "view-title-sub" }, "周报索引 / 更新日志 / 其他资源"),
  ]);

  const tabs = moreSubsectionTabs({ active: child });

  const childNode = child === "changelog" ? renderChangelogView() : renderWeeksIndexView();

  const body = el("div", { class: "main-pane view-body more-body" }, [childNode]);

  return el("section", {
    class: "view view-more",
    "data-view": "more",
    "data-child": child,
  }, [title, tabs, body]);
}